module.exports = __webpack_public_path__ + "img/hand-color.cb1c208e.png";